var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card',{attrs:{"title":"Users","subtitle":''}},[_c('div',[_c('Users-Table')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }